import clsx from "clsx"
import { ComponentProps } from "react"

export type SvgProps = ComponentProps<"svg">

export type AdditionalSpriteIconProps<T extends string> = {
  name: T
}

export type SpriteIconProps<T extends string> = SvgProps & AdditionalSpriteIconProps<T>

export function createSpriteIconComponent<T extends string>(spriteUrl: string) {
  const spriteName = spriteUrl.split("/").pop()!.split(".")[0]!

  return function SpriteIcon({ name, className, ...props }: SpriteIconProps<T>) {
    return (
      <svg
        {...props}
        aria-label={name}
        className={clsx(
          "pointer-events-none",
          className,
          !className?.includes("size-") && !className?.includes("h-") && !className?.includes("w-") && "size-6",
          !className?.includes("shrink-") && "shrink-0",
        )}
      >
        <title>{name}</title>
        <use xlinkHref={spriteUrl + "#" + spriteName + "-" + name} />
      </svg>
    )
  }
}
